<template>
<!-- 处方笺 -->
  <div class="wrapper" v-if="showTemplate">
    <div class="drug" v-for="info of recipeInfo" :key="info.recipeId">
      <com-prescription :showData="info"></com-prescription>
    </div>
    <div class="appointment">
      <div class="validity" v-if="recipeInfo[0].useStatus != 8">
       {{ recipeInfo[0].useStatus == 7 ? '您的处方已过期' : '您已完成预约，请勿重复预约药品'}}</div>
      <div class="validity" v-if="recipeInfo[0].useStatus == 8">处方有效期至: {{expireTime}} 请您尽快预约药品</div>
      <div class="btn" @click="toAppointment"  v-if="recipeInfo[0].useStatus == 8">预约药品</div>
    </div>
  </div>
</template>
<script>
import comPrescription from '../components/PrescriptionCommon.vue';
import axios from '../services/recipe';

// import {Toast as VanToast, Dialog} from 'vant';

export default {
  data() {
    return {
      showChatQR: false,
      recipeData: '',
      expireTime: '',
      timeShow: true,
      showTemplate: false,
      recipeInfo: [],
    };
  },
  components: { comPrescription },
  mounted() {
    this.getPrescriptionInfo();
  },
  methods: {
    // 获取处方笺信息
    getPrescriptionInfo() {
      const params = {
        recipeId: this.$route.params.id,
      };
      axios.getRecipeInfo(params).then(res => {
        if (res.data.data.status && res.data.data.status === 'success') {
          this.recipeInfo = res.data.data.data instanceof Array ? res.data.data.data : [res.data.data.data];
          this.recipeInfo.forEach(info => {
            if (info.diagnose) {
              const diagnoseStr = info.diagnose.join('，');
              info.diagnoseStr = diagnoseStr;
            }
            if (info.gender == 1) {
              info.sex = '男';
            } else if (info.gender == 2) {
              info.sex = '女';
            } else {
              info.sex = '';
            }
          });
          this.timeFn(this.recipeInfo[0].validTerm);
          this.showTemplate = true;
        }
      });
    },
    // 时间处理
    timeFn(date) {
      if (!date) {
        return;
      }
      let dateBegin = Date.parse(new Date(date.replace(/-/g, '/')));
      dateBegin = new Date(dateBegin + 24 * 60 * 60 * 1000);
      const years = dateBegin.getFullYear();
      const month = dateBegin.getMonth() + 1;
      const dates = dateBegin.getDate();
      this.expireTime = `${years}-${month}-${dates}`;
    },

    toAppointment() {
      this.$router.push({
        path: `/orderBuyDrug/${this.$route.params.id}`,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  overflow: hidden;
  background-color: #fff;
  min-height: 100vh;
  .drug {
    text-align: left;
    margin-bottom: 128px;
  }

  .appointment {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 120px;
    background: #ffffff;
    .validity {
      font-size: 14px;
      color: #f86e21;
      height: 30px;
      line-height: 30px;
      background: #fefcec;
      text-align: center;
      margin-bottom: 5px;
    }
    .btn {
      height: 44px;
      line-height: 44px;
      font-size: 18px;
      color: #fff;
      text-align: center;
      margin-left: 15px;
      margin-right: 15px;
      background: #208fe3;
      border-radius: 4px;
    }
  }
  .QR-title {
    width: 246px;
  }
  .dialog-content {
    font-family: PingFangSC-Medium;
    font-size: 13px;
    color: #000000;
    text-align: center;
    margin: 30px 0;
  }
  .QR-img {
    width: 171px;
    height: 171px;
    border: 4px solid #46D89F;
    margin-bottom: 10px;
  }
  .QR-text {
    margin-bottom: 10px;
  }
}
</style>
